import { Key } from "react";

import { UserProfile } from "shared/interfaces/api";

export interface GetEmployeesParams {
  name?: string;
  notAssignedToProperty?: string | number;
  roleId?: Key;
  nameOrEmail?: string;
  activeOnly?: boolean;
  page?: number;
  pageSize?: number;
}

export interface Employee {
  canAccessEverything: boolean;
  canInviteEmployee?: boolean;
  company: number;
  companyDismissed: boolean;
  createdAt: Date;
  deleted?: boolean;
  id: number;
  /** When API exposes it: invitation exists and accepted_at is null (setup not completed). */
  accountSetupPending?: boolean;
  isActive: boolean;
  isOpenApi: boolean;
  numAssignedProperties: number;
  updatedAt: Date;
  role: {
    company: number;
    createdAt: Date;
    deleted?: boolean;
    id: number;
    name: string;
    numEmployees: number;
    updatedAt: Date;
  };
  user: UserProfile;
}

/** Match GET /employees/ row shape: account_setup_pending from EmployeeSerializer (camelCased client-side). */
export const shouldShowResendInviteForEmployee = (
  employee: Employee
): boolean =>
  Boolean(employee.isActive && employee.accountSetupPending === true);

export interface EmployeesWithCount {
  count: number;
  results: Employee[];
}

export interface UnassignEmployeeFromPortfolioProps {
  values: {
    properties: Key[];
    portfolios: Key[];
  };
  employeeId: Key;
}
